export interface Preguntas {
  id: number;
  pregunta: string;
  respuesta: string;
  activa: string;
  created_at: Date | string;
  updated_at: null;
}

export const preguntas: Preguntas[] = [
  {
    id: 1,
    pregunta: '¿Para qué sirve el Portal de Autogestión?',
    respuesta:
      'El nuevo Portal le permite interactuar más fácilmente con la Municipalidad de San Miguel y mantenerse informado sobre las deudas de sus bienes.',
    activa: '1',
    created_at: '2022-10-12T15:57:13.000000Z',
    updated_at: null,
  },
  {
    id: 2,
    pregunta: '¿Qué necesito para usar el Portal?',
    respuesta:
      'Para acceder, necesita su CUIT y una Clave personal (a elección suya). Para registrarse vaya al botón que lo indica, donde le vamos a pedir que se registre utilizando su CUIT/CUIL (que puede obtener aquí) y que nos brinde una casilla de email válida donde le enviaremos un email para completar el proceso de registro.Con el email recibido podrá confirmar su acceso y las próximas veces podrá ingresar directamente al portal con su CUIT/CUIL y su Clave personal.',
    activa: '1',
    created_at: '2022-10-12T15:57:13.000000Z',
    updated_at: null,
  },
  {
    id: 3,
    pregunta: '¿Por qué es obligatorio el email?',
    respuesta:
      'Actualmente es la forma más práctica de ponernos en contacto con usted si surgiera algún problema. De la misma manera, al estar verificada la casilla en el momento del registro, si alguna vez tuviese un problema con algún pago realizado a través del sitio, podemos referirnos a dicho email para tratar con un interlocutor válido.',
    activa: '1',
    created_at: '2022-10-12T15:57:14.000000Z',
    updated_at: null,
  },
  {
    id: 4,
    pregunta: '¿Qué puedo hacer en el Portal?',
    respuesta:
      'El Portal permite conocer la deuda en sus Inmuebles y/o Rodados, descargar las boletas de pago, realizar pagos online con tarjetas de crédito y solicitar convenios de pago para regularizar su situación.',
    activa: '1',
    created_at: '2022-10-12T15:57:14.000000Z',
    updated_at: null,
  },
  {
    id: 5,
    pregunta: '¿Qué tasas puedo descargar boletas o pagar?',
    respuesta:
      'En el Portal de Autogestión se podrá abonar las siguientes Tasas: Inmuebles, Rodados, Motos, Servicios Municipales, Derecho de Construcción, Derecho de Mensura.',
    activa: '1',
    created_at: '2022-10-12T15:57:14.000000Z',
    updated_at: null,
  },
  {
    id: 6,
    pregunta: '¿Cómo utilizo el Portal?',
    respuesta:
      'Luego de acceder, deberá agregar al menos un elemento de los que quiere consultar, como puede ser un Inmueble o Rodado. En la pantalla de agregar puede poner un nombre amistoso para identificar fácilmente dicho elemento a lo largo del tiempo. Ese elemento aparecerá cada vez que ingrese al sitio, hasta que usted decida eliminarlo del portal (puede eliminarlo utilizando la cruz en la esquina superior derecha). Cada elemento mostrará un ícono por cada tasa que tenga asociada, donde puede acceder haciendo y visualizar el detalle con un simple click.',
    activa: '1',
    created_at: '2022-10-12T15:57:14.000000Z',
    updated_at: null,
  },
  {
    id: 7,
    pregunta: '¿Qué son los íconos que aparecen en las Tasas?',
    respuesta:
      'Existen dos íconos actualmente, uno verde que aparece junto con la leyenda "Al día" y significa que no posee deuda en dicha tasa , y otro rojo que indica que hay un convenio de pago asociado a dicho elemento, y puede o no tener deuda, pero el convenio de pago aún está vigente y sin cancelar.',
    activa: '1',
    created_at: '2022-10-12T15:57:14.000000Z',
    updated_at: null,
  },
  {
    id: 8,
    pregunta: '¿Cómo agrego un Inmueble/Rodado?',
    respuesta:
      'Puede agregarlo utilizando el botón [+] que se encuentra al final de los elementos que ya tiene asociados. La primera vez que ingresa, este es el único elemento que tiene disponible.',
    activa: '1',
    created_at: '2022-10-12T15:57:14.000000Z',
    updated_at: null,
  },
  {
    id: 9,
    pregunta: '¿Cómo elimino un Inmuelbe/Rodado?',
    respuesta:
      'Puede eliminar cualquier elemento asociado utilizando el botón [X] que se encuentra en el marco superior derecho de los elementos que ya tiene asociados ó utilizando el mismo botón [X] que también aparece en la vista de detalle de cualquier elemento asociado.',
    activa: '1',
    created_at: '2022-10-12T15:57:14.000000Z',
    updated_at: null,
  },
];

export interface taxTypes {
  name: string;
  value: 'COM' | 'INM' | 'CEM' | 'ROD' | 'CON' | 'MUL' | 'ALM';
}

export const taxTypes: taxTypes[] = [
  {
    name: 'Comercio',
    value: 'COM',
  },
  {
    name: 'Inmueble',
    value: 'INM',
  },
  {
    name: 'Rodado',
    value: 'ROD',
  },
  {
    name: 'Contribuyentes',
    value: 'CON',
  },
  {
    name: 'Alumnos',
    value: 'ALM',
  },
];
